import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { MusicProvider } from '@/contexts/MusicContext';
import { AuthProvider, ProtectedRoute, LoginPage } from './AuthPages';
import {
  AdminDashboard, AdminGallery, AdminBlog,
  AdminContacts, AdminTestimonials, AdminUsers, AdminSettings
} from './AdminPages';
import AdminAnalytics from './AdminAnalytics';
import AnalyticsTracker from '@/components/common/AnalyticsTracker';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import MapInfoSection from '@/components/sections/MapInfoSection';
import PrivacyBanner from '@/components/sections/PrivacyBanner';
import PrivacidadePage from '@/components/pages/PrivacidadePage';
import { BlogPage, BlogPostPage } from '@/components/pages/BlogPages';
import { HomePage, TrabalheConoscoPage, OrcamentoPage } from '@/components/pages/HomePage';
import ExperienciaPage from '@/components/pages/ExperienciaPage';

function App() {
  return (
    <div className="App bg-white min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <MusicProvider>
          <AnalyticsTracker />
          <Routes>
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/analytics" element={<ProtectedRoute><AdminAnalytics /></ProtectedRoute>} />
            <Route path="/admin/gallery" element={<ProtectedRoute><AdminGallery /></ProtectedRoute>} />
            <Route path="/admin/blog" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
            <Route path="/admin/contacts" element={<ProtectedRoute><AdminContacts /></ProtectedRoute>} />
            <Route path="/admin/testimonials" element={<ProtectedRoute><AdminTestimonials /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            <Route path="/experiencia" element={<ExperienciaPage />} />
            <Route path="/*" element={<><Header /><Routes><Route path="/" element={<HomePage />} /><Route path="/trabalhe-conosco" element={<TrabalheConoscoPage />} /><Route path="/orcamento" element={<OrcamentoPage />} /><Route path="/blog" element={<BlogPage />} /><Route path="/blog/:slug" element={<BlogPostPage />} /><Route path="/privacidade" element={<PrivacidadePage />} /></Routes><MapInfoSection /><Footer /><PrivacyBanner /></>} />
          </Routes>
          </MusicProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
